import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import './icons.svg';

export const iconSet = {
  arrowright: 'arrowright',
  check: 'check',
  chevronleft: 'chevronleft',
  chevronup: 'chevronup',
  chevronright: 'chevronright',
  chevrondown: 'chevrondown',
  play: 'play',
  plus: 'plus',
  filterdown: 'filterdown',
  hamburger: 'hamburger',
  info: 'info',
  message: 'message',
  marker: 'marker',
  thumbsdown: 'thumbsdown',
  thumbsup: 'thumbsup',
  x: 'x',
  search: 'search',
  send: 'send',
  user: 'user',
  next: 'next',
  prev: 'prev',
  verifiedUser: 'verified_user'
};

const Wrapper = styled.svg`
  display: block;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  fill: ${props => (props.color ? props.color : 'currentColor')};
  pointer-events: none;
`;

export const Icon = ({ name, size = 40, color, className }) => (
  <Wrapper size={size} color={color} className={className}>
    <use xlinkHref={`#icons_icon-${name}`} />
  </Wrapper>
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js